import { StakingEnrollmentStatus } from '@app/codegen';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

export const StakingEnrollmentsScreenFilterSchema = yup
	.object({
		search: yup.string().default(''),
		status: yup
			.mixed<StakingEnrollmentStatus>()
			.oneOf(Object.values(StakingEnrollmentStatus))
			.default(undefined),
		createdAt: yup.date().default(undefined),
		id: yup.string().default('').max(12),
	})
	.defined();

export type FilterStakingEnrollmentsForm = yup.TypeOf<typeof StakingEnrollmentsScreenFilterSchema>;

export function useStakingEnrollmentsScreenFilterForm() {
	return useForm<FilterStakingEnrollmentsForm>({
		mode: 'all',
		resolver: yupResolver(StakingEnrollmentsScreenFilterSchema),
		defaultValues: StakingEnrollmentsScreenFilterSchema.cast({}),
	});
}
